import React from "react";

export default function PreviewAvatarImage({ file }) {
  const [preview, setPreview] = React.useState(null);

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    setPreview(reader.result);
  };

  return (
    <div className="text-center">
      <img
        src={preview}
        alt="Preview"
        className="inline-block h-12 w-12 rounded-full"
      />
    </div>
  );
}
